import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// import InputMask from 'inputmask-core';

// UI
import P from "../paragraph";
import Datepicker from "../datepicker";
import Monthpicker from "../monthpicker";

class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFocused: false
    };

    this.onKeyPressNumber = this.onKeyPressNumber.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onFocusMonthpicker = this.onFocusMonthpicker.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onBlurNumber = this.onBlurNumber.bind(this);
    this.onBlurMonthpicker = this.onBlurMonthpicker.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  // componentWillMount() {
  //   if (this.props.mask) {
  //     this.setState({mask: new InputMask({pattern: this.props.mask, value: this.props.value})})
  //   }
  // }

  onKeyPressNumber(e) {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    const regexpNumbers = this.props.positive ? /\d|\.|,/ : /\d|-|\.|,/;

    if (this.props.type === "number" || this.props.type === "integer") {
      if (regexpNumbers.test(keyValue)) {
        let currentValue = e.currentTarget.value;
        const value = e.target.value;

        const isFirstMinus = value.charAt(0) === "-";
        const lastSymbol = value.charAt(value.length - 1);
        const indexDot = value.indexOf(".");

        // Если цифра
        if (/\d/.test(keyValue)) {
          if (currentValue === "0" || currentValue === "-0") {
            if (keyValue !== "0") {
              if (currentValue === "0") {
                console.log(
                  "Edit " + keyValue + ' key: "0" => "' + keyValue + '"'
                );

                e.currentTarget.value = keyValue;
                e.target.value = keyValue;
              } else {
                console.log(
                  "Edit " + keyValue + ' key: "-0" => "-' + keyValue + '"'
                );

                e.currentTarget.value = "-" + keyValue;
                e.target.value = "-" + keyValue;
              }

              e.preventDefault();

              this.onChange(e);
            } else {
              console.log('Block "0" key: Значение равно "0"');

              e.preventDefault();
              return null;
            }
          } else {
            if (indexDot !== -1 && this.props.postfixNumberMax !== 0) {
              const postfixLength = String(value).substring(
                indexDot + 1,
                String(value).length
              ).length;

              if (postfixLength >= this.props.postfixNumberMax) {
                console.log(
                  'Block "' +
                    keyValue +
                    '" key: Максимальное количество после точки ("' +
                    this.props.postfixNumberMax +
                    '")'
                );

                e.preventDefault();
                return null;
              } else {
                console.log(
                  'Edit "' +
                    keyValue +
                    '" key: "' +
                    currentValue +
                    '" => "' +
                    (currentValue + keyValue) +
                    '"'
                );

                e.currentTarget.value = currentValue + keyValue;
                e.target.value = currentValue + keyValue;

                e.preventDefault();

                this.onChange(e);
              }
            } else {
              let preCurentValue = currentValue;
              const firstCharCheckZero = isFirstMinus ? 1 : 0;

              if (String(currentValue).charAt(firstCharCheckZero) === "0") {
                currentValue =
                  (isFirstMinus ? "-" : "") +
                  String(currentValue).substring(
                    firstCharCheckZero + 1,
                    currentValue.length
                  ) +
                  keyValue;
              } else {
                currentValue = currentValue + keyValue;
              }

              console.log(
                'Edit "' +
                  keyValue +
                  '" key: "' +
                  preCurentValue +
                  '" => "' +
                  currentValue +
                  '"'
              );

              e.currentTarget.value = currentValue;
              e.target.value = currentValue;

              e.preventDefault();

              this.onChange(e);
            }
          }
        }

        // Если точка или ,
        if (keyValue === "." || keyValue === ",") {
          if (this.props.type !== "integer") {
            // Если последний символ .
            if (lastSymbol === ".") {
              console.log('Block "." or "," key: Последний символ "."');

              e.preventDefault();
              return null;
            }

            if (keyValue === ".") {
              // Если пусто
              if (currentValue === "") {
                console.log('Edit . key: "" => "0"');

                e.target.value = "0";
                // Если -
              } else if (currentValue === "-") {
                console.log('Edit . key: "-" => "-0"');

                e.target.value = "-0";
              } else {
                // Что-то есть в значении (не пустое)
                // Уже есть точка
                if (value.indexOf(".") !== -1) {
                  console.log('Block . key: Уже есть "."');

                  e.preventDefault();
                  return null;
                } else {
                  console.log('Add "."');
                }
              }
            } else {
              console.log("Обработка ,");

              // Если пусто
              if (currentValue === "") {
                console.log('Edit , key: "" => "0."');

                e.currentTarget.value = "0.";
                e.target.value = "0.";

                e.preventDefault();

                this.onChange(e);
                // Если -
              } else if (currentValue === "-") {
                console.log('Edit , key: "-" => "-0."');

                e.currentTarget.value = "-0.";
                e.target.value = "-0.";

                e.preventDefault();

                this.onChange(e);
              } else {
                // Что-то есть в значении (не пустое)
                // Уже есть точка
                if (value.indexOf(".") !== -1) {
                  console.log('Block , key: Уже есть "."');

                  e.preventDefault();
                  return null;
                } else {
                  console.log('Edit , key: "," => "."');

                  e.currentTarget.value = currentValue + ".";
                  e.target.value = currentValue + ".";

                  e.preventDefault();

                  this.onChange(e);
                }
              }
            }
          } else {
            console.log("Block , or . key: Only integer");

            e.preventDefault();
            return null;
          }
        }

        // Если -
        if (keyValue === "-") {
          if (currentValue === "") {
            console.log('Add "-"');
          } else {
            if (currentValue.indexOf("-") === -1) {
              console.log('Edit - key: Вставка "-" в начало');

              e.currentTarget.value = "-" + currentValue;
              e.target.value = "-" + currentValue;

              e.preventDefault();
              return null;
            } else {
              console.log('Edit - key: Убираем "-" с начала');

              e.currentTarget.value = currentValue.substring(
                1,
                currentValue.length
              );
              e.target.value = currentValue.substring(1, currentValue.length);

              e.preventDefault();
              return null;
            }
          }
        }
      } else {
        e.preventDefault();
        return null;
      }
    }
    // else if (this.props.mask) {
    //   const keyValue = String.fromCharCode(keyCode);

    //   const resultInput = mask.input(keyValue);
    // }
  }

  onFocus(e) {
    this.setState({ isFocused: true });
  }

  onFocusMonthpicker(e) {
    this.setState({ isFocused: true });
  }

  onBlur(e) {
    this.setState({
      isFocused: false
    });

    if (this.props.onBlur) {
      this.props.onBlur(e);
    } else {
      if (this.props.type === "number" || this.props.type === "integer") {
        this.onBlurNumber(e);
      } else {
        this.props.handleChange(e);
      }
    }
  }

  onBlurNumber(e) {
    let currentValue = e.currentTarget.value;
    let value = e.target.value;

    const isFirstMinus = value.charAt(0) === "-";
    const lastSymbol = value.charAt(value.length - 1);
    const indexDot = currentValue.indexOf(".");
    const prefixNumber = String(currentValue).substring(0, indexDot) || "";

    function isNeedZero(tempValue) {
      return (
        !tempValue.length ||
        tempValue === "" ||
        tempValue === "-" ||
        tempValue === "." ||
        tempValue === "-." ||
        tempValue === "0" ||
        tempValue === "-0" ||
        tempValue === "0." ||
        tempValue === "-0."
      );
    }

    // Set 0 if null
    if (isNeedZero(currentValue)) {
      if (this.props.type === "integer") {
        if (prefixNumber === "" || prefixNumber === "-") {
          console.log('Edit "" || "-" || "0" || "-0" || "0." || "-0." => "0"');

          e.currentTarget.value = "0";
          e.target.value = "0";
        }
      } else {
        console.log('Edit "" || "-" || "0" || "-0" || "0." || "-0." => "0"');

        e.currentTarget.value = "0";
        e.target.value = "0";
      }
    } else {
      if (lastSymbol === ".") {
        currentValue = String(e.currentTarget.value).substring(
          0,
          String(e.currentTarget.value).length - 1
        );
        value = String(e.target.value).substring(
          0,
          String(e.target.value).length - 1
        );

        console.log('Edit "' + e.target.value + '" => "' + value + '"');

        e.currentTarget.value = currentValue;
        e.target.value = value;
      } else {
        // Если есть точка в выражении?
        if (indexDot !== -1) {
          // Если число < 0, то добавляем минус в начало выражения
          let prefixMinus = isFirstMinus ? "-" : "";
          // Берём число, которое находится беред точной
          const prefixNumber =
            parseInt(String(currentValue).substring(0, indexDot), 10) || 0;

          // Парсим строку, которая находиться после точки
          const postfixString = String(currentValue).substring(
            indexDot + 1,
            // Ищем конец выражения...
            indexDot + 4 < String(currentValue).length
              ? indexDot + 4
              : String(currentValue).length
          );
          // Берём число после точки
          const postfixNumber = parseInt(postfixString, 10) || 0;

          currentValue = prefixNumber;

          // Если перед точной 0
          if (prefixNumber === 0) {
            // Если после точки 0
            if (postfixNumber === 0) {
              console.log(
                'Edit 1 - "' +
                  e.currentTarget.value +
                  '" => "' +
                  currentValue +
                  '"'
              );

              e.currentTarget.value = currentValue;
              e.target.value = currentValue;
            } else {
              // После точки не 0
              currentValue = prefixMinus + currentValue + "." + postfixString;

              console.log(
                'Edit 2 - "' +
                  e.currentTarget.value +
                  '" => "' +
                  currentValue +
                  '"'
              );

              e.currentTarget.value = currentValue;
              e.target.value = currentValue;
            }
          } else {
            // Если перед точной не 0
            if (postfixNumber === 0) {
              currentValue = prefixMinus + currentValue;

              console.log(
                'Edit 3 - "' +
                  e.currentTarget.value +
                  '" => "' +
                  currentValue +
                  '"'
              );

              e.currentTarget.value = currentValue;
              e.target.value = currentValue;
            }
          }
        } else {
          currentValue = parseInt(e.currentTarget.value, 10) || 0;

          console.log(
            'Edit "' + e.currentTarget.value + '" => "' + currentValue + '"'
          );

          e.currentTarget.value = currentValue;
          e.target.value = currentValue;
        }
      }
    }

    this.props.handleChange(e);

    // Float
    // -123.11 | 123.11 | 1 | 123 | -1 | -123
    // /^(-\d{1,11}|\d{1,11})((\.\d{1,2})?)$/g

    // Integer (+ / -)
    // 1 | 123 | -1 | -123
    // /^(-\d{1,11}|\d{1,11})$/g

    // Integer (only +)
    // 1 | 123
    // /^\d{1,11}$/g
  }

  onBlurMonthpicker(value) {
    this.setState({ isFocused: false });

    this.props.handleChangeMonth(this.props.name, value);
  }

  onChange(e) {
    this.props.handleChange(e);
  }

  render() {
    /* CLASS */
    const inputClasses = classNames(
      "input",
      {
        [`size-${this.props.size}`]: this.props.size,
        checkbox: this.props.type === "checkbox",
        datepicker: this.props.type === "date",
        block: this.props.block,
        focus: this.state.isFocused,
        /* Ошибка при валидации */
        error:
          this.props.isError || (this.props.errors && this.props.errors.length)
      },
      this.props.className
    );

    const inputGroupClasses = classNames(
      "input--group",
      {
        "margin-no": this.props.inTable
      },
      this.props.inputGroupClassName
    );

    /* PROPS */
    const {
      label,
      name,
      type,
      value,
      placeholder,
      autoFocus,
      disabled,
      errors
    } = this.props;

    /* INPUT */
    const InputElement = React.createElement("input", {
      id: name,
      type: type === "password" || type === "checkbox" ? type : "text",
      name,
      value,
      placeholder,
      autoFocus,
      disabled,
      onChange: this.props.type === "month" ? null : this.onChange,
      onKeyPress: this.props.type === "month" ? null : this.onKeyPressNumber,
      onKeyDown: this.props.handleKeyDown,
      onBlur: this.props.type === "month" ? null : this.onBlur,
      onFocus:
        this.props.type === "month" ? this.onFocusMonthpicker : this.onFocus,
      className: inputClasses
    });

    /* ERRORS */
    let errorsMessages = null;
    if (errors && errors.length) {
      errorsMessages = errors.map(error =>
        React.createElement(
          P,
          { size: "x-small", margin: "no", key: error },
          error
        )
      );
    }
    const errorClasses = classNames("input--errors", {
      /* Ошибка при валидации */
      error: errors && errors.length
    });
    const ErrorsElement = React.createElement(
      "div",
      { className: errorClasses },
      errorsMessages
    );

    /* RENDER */
    if (this.props.type === "checkbox") {
      /* LABEL */
      let LabelCheckboxElement = null;
      if (label) {
        const labelClasses = classNames("label", this.props.labelClassName);

        LabelCheckboxElement = React.createElement(
          "label",
          { htmlFor: name, className: labelClasses },
          InputElement,
          label
        );
      } else {
        LabelCheckboxElement = InputElement;
      }

      return React.createElement(
        "div",
        { className: inputGroupClasses },
        LabelCheckboxElement,
        ErrorsElement
      );
    } else if (this.props.type === "date" || this.props.type === "date-full") {
      /* LABEL */
      let LabelElement = null;
      if (label) {
        const labelClasses = classNames("label", this.props.labelClassName);

        LabelElement = React.createElement(
          "label",
          { htmlFor: name, className: labelClasses },
          label
        );
      }

      const datepickerOverlayClassName = classNames(
        {
          top: this.props.dateTop,
          right: this.props.dateRight,
          type: this.props.type
        },
        this.props.datepickerOverlayClassName
      );

      const DatePickerElement = React.createElement(Datepicker, {
        name,
        value,
        placeholder,
        disabled,
        full: this.props.type === "date-full",
        onChange: this.props.handleChangeDate,
        inputProps: {
          id: name,
          type: "text",
          name,
          placeholder,
          autoFocus,
          disabled,
          onChange: this.onChange,
          onKeyPress: this.onKeyPressNumber,
          onBlur: this.onBlur,
          className: inputClasses
        },
        datepickerFullClassName: this.props.datepickerFullClassName,
        datepickerContainerClassName: this.props.datepickerContainerClassName,
        datepickerOverlayWrapperClassName: this.props
          .datepickerOverlayWrapperClassName,
        datepickerOverlayClassName: datepickerOverlayClassName
      });

      return React.createElement(
        "div",
        { className: inputGroupClasses },
        LabelElement,
        DatePickerElement,
        ErrorsElement
      );
    } else if (this.props.type === "month") {
      /* LABEL */
      let LabelElement = null;
      if (label) {
        const labelClasses = classNames("label", this.props.labelClassName);

        LabelElement = React.createElement(
          "label",
          { htmlFor: name, className: labelClasses },
          label
        );
      }

      const datepickerOverlayClassName = classNames(
        {
          top: this.props.dateTop,
          right: this.props.dateRight,
          type: this.props.type
        },
        this.props.datepickerOverlayClassName
      );

      const month =
        (value &&
          value.length &&
          value.length === 7 &&
          parseInt(String(value).split(".")[0] || 0, 10)) ||
        0;
      const year =
        (value &&
          value.length &&
          value.length === 7 &&
          parseInt(String(value).split(".")[1] || 0, 10)) ||
        0;

      console.log("value:", value, month, year);

      const MonthPickerElement = React.createElement(Monthpicker, {
        month,
        year,
        isShow: this.state.isFocused,
        onChange: this.onBlurMonthpicker,
        datepickerOverlayClassName: datepickerOverlayClassName
      });

      return React.createElement(
        "div",
        { className: inputGroupClasses },
        LabelElement,
        React.createElement(
          "div",
          { className: "datepicker-container" },
          InputElement,
          MonthPickerElement
        ),
        ErrorsElement
      );
    } else {
      /* LABEL */
      let LabelElement = null;
      if (label) {
        const labelClasses = classNames("label", this.props.labelClassName);

        LabelElement = React.createElement(
          "label",
          { htmlFor: name, className: labelClasses },
          label
        );
      }

      return React.createElement(
        "div",
        { className: inputGroupClasses },
        LabelElement,
        InputElement,
        ErrorsElement
      );
    }
  }
}

Input.defaultProps = {
  name: null,
  type: "text",
  positive: false,
  value: "",
  // mask: null,
  placeholder: null,
  size: null,
  block: false,
  disabled: false,
  postfixNumberMax: 3,
  onBlur: null,
  handleChange: () => {
    return null;
  },
  handleChangeDate: () => {
    return null;
  },
  handleChangeMonth: () => {
    return null;
  },
  handleKeyDown: () => {
    return null;
  },
  label: null,
  isError: false,
  dateTop: false,
  dateRight: false,
  autoFocus: false,
  inTable: false,
  errors: [],
  className: null,
  inputGroupClassName: null,
  labelClassName: null,
  datepickerFullClassName: null,
  datepickerContainerClassName: null,
  datepickerOverlayWrapperClassName: null,
  datepickerOverlayClassName: null
};

Input.propTypes = {
  name: PropTypes.string,
  type: PropTypes.oneOf([
    "text",
    "number",
    "integer",
    "password",
    "date",
    "date-full",
    "month"
  ]),
  positive: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // mask: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(["s", "m", "l", "xl"]),
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  postfixNumberMax: PropTypes.number,
  onBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleChangeDate: PropTypes.func,
  handleChangeMonth: PropTypes.func,
  handleKeyDown: PropTypes.func,
  label: PropTypes.string,
  isError: PropTypes.bool,
  dateTop: PropTypes.bool,
  dateRight: PropTypes.bool,
  autoFocus: PropTypes.bool,
  inTable: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  inputGroupClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  datepickerFullClassName: PropTypes.string,
  datepickerContainerClassName: PropTypes.string,
  datepickerOverlayWrapperClassName: PropTypes.string,
  datepickerOverlayClassName: PropTypes.string
};

export default Input;
